export const DINING = 'DINING';
export const TAKEAWAY = 'TAKEAWAY';
export const DELIVERY = 'DELIVERY';
export const ASAP = 'ASAP';
export const CALENDAR = 'CALENDAR';
export const RESET_STORE = 'RESET_STORE'; 
